import { fetcher, queryString, useRecoilQuery } from '@shared/hooks/recoil-query';
import { LowerRole } from '@shared/types';

import {
  giftItemDataAtomFamily,
  giftItemForStoreDataAtomFamily,
  giftItemForStoreStatusAtomFamily,
  giftItemListDataAtom,
  giftItemListForBugoAgencyAdminDataAtom,
  giftItemListForBugoAgencyAdminStatusAtom,
  giftItemListForStoreDataAtomFamily,
  giftItemListForStoreStatusAtomFamily,
  giftItemListStatusAtom,
  giftItemStatusAtomFamily,
} from './giftItem.atom';

const giftItemPopulate = {
  populate: [
    {
      path: 'giftItemInfo',
      populate: [
        'image',
        'detailImages',
        'headerImages',
        'deliveredImageList',
        { path: 'choiceUnits', populate: ['image'] },
      ],
    },
    { path: 'bugoBrand' },
    { path: 'image' },
    { path: 'headerImages' },
    { path: 'detailImages' },
    { path: 'deliveredImageList' },
  ],
};

const giftItemListPopulate = {
  populate: [
    { path: 'giftItemInfo', populate: ['image'] },
    { path: 'bugoBrand' },
    { path: 'image' },
  ],
};

export const giftItemListUrl = (role: LowerRole) =>
  `${role}/gift-item?${queryString(giftItemListPopulate)}`;

export const useGiftItemListHook = (role: LowerRole) => {
  useRecoilQuery(
    giftItemListStatusAtom,
    giftItemListDataAtom,
    giftItemListUrl(role),
    fetcher,
  );
};

export const giftItemUrl = (id: string, role: LowerRole) =>
  `${role}/gift-item/${id}?${queryString(giftItemPopulate)}`;

export const useGiftItemHook = (id: string, role: LowerRole) => {
  useRecoilQuery(
    giftItemStatusAtomFamily(id),
    giftItemDataAtomFamily(id),
    giftItemUrl(id, role),
    fetcher,
  );
};

export const useGiftItemListForBugoAgencyAdminHook = () => {
  useRecoilQuery(
    giftItemListForBugoAgencyAdminStatusAtom,
    giftItemListForBugoAgencyAdminDataAtom,
    giftItemListUrl(LowerRole.BugoAgencyAdmin),
    fetcher,
  );
};

export const giftItemListForStoreUrl = (bugoId: string) =>
  `public/gift-item/by-bugo?bugo=${bugoId}`;

export const useGiftItemListForStoreHook = (bugoId: string) => {
  useRecoilQuery(
    giftItemListForStoreStatusAtomFamily(bugoId),
    giftItemListForStoreDataAtomFamily(bugoId),
    giftItemListForStoreUrl(bugoId),
    fetcher,
  );
};

export const giftItemForStoreUrl = (id: string) => `public/gift-item/${id}`;

export const useGiftItemForStoreHook = (id: string) => {
  useRecoilQuery(
    giftItemForStoreStatusAtomFamily(id),
    giftItemForStoreDataAtomFamily(id),
    giftItemForStoreUrl(id),
    fetcher,
  );
};
